export const FETCH_FASTAG_PROVIDER = '/api/app/fastag/?type=biller_detail'

export const BILLER_API = (regNo: string, billerDetailsId: string) =>
  `/api/app/fastag/?regNo=${regNo}&?biller_id=${billerDetailsId}&?type=fastag_balance`

export const AUTO_API = (regNo: string) => `/api/app/fastag/?regNo=${regNo}&?type=autoApi`

export const APPFLYER_DEEP_LINK = (regNo: string) => `/api/app/fastag/?regNo=${regNo}&type=fastag_deep_link`
